import React from 'react';
import PropTypes from 'prop-types';

// Lodash
import _map from 'lodash/map';
import _noop from 'lodash/noop';

// Constants
import { EMPTY_ARRAY, EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import { VIEW_TYPE } from '../../../constants/note.general';

// Components
import Tag from '../../../../../atoms/Tag';
import { UserInfoCompact } from '../../../../UserInfo';
import TimeStamp from '../../../TimeStamp';
import ActionButtons from '../../../ActionButtons';
import NoteEditor from '../../../NoteEditor';
import styles from './compactNoteItem.module.scss';
var CompactNoteItem = function CompactNoteItem(props) {
  var editing = props.editing,
    userImage = props.userImage,
    userName = props.userName,
    userRole = props.userRole,
    noteDate = props.noteDate,
    hideActions = props.hideActions,
    noteActions = props.noteActions,
    isNoteEdited = props.isNoteEdited,
    noteText = props.noteText,
    handleAddOrUpdate = props.handleAddOrUpdate,
    validators = props.validators,
    className = props.className,
    tags = props.tags,
    associatedUsers = props.associatedUsers,
    enableMentions = props.enableMentions,
    personas = props.personas;
  var noteEditorClassName = editing ? styles.editor : styles.note;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles.compactNoteItem, " ").concat(className)
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-content-between"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex align-items-start ".concat(styles.detailsContainer)
  }, /*#__PURE__*/React.createElement(UserInfoCompact, {
    image: userImage,
    userName: userName,
    userRole: userRole,
    contentClassName: "m-t-4"
  }), /*#__PURE__*/React.createElement(TimeStamp, {
    containerClassName: "m-t-4",
    date: noteDate,
    view: VIEW_TYPE.COMPACT
  }), _map(tags, function (tag) {
    return /*#__PURE__*/React.createElement(Tag, {
      className: styles.tagContainer
    }, tag);
  })), !hideActions && /*#__PURE__*/React.createElement(ActionButtons, {
    actions: noteActions
  })), /*#__PURE__*/React.createElement(NoteEditor, {
    view: VIEW_TYPE.COMPACT,
    isUpdate: editing,
    isEdited: isNoteEdited,
    note: noteText,
    handleAddOrUpdate: handleAddOrUpdate,
    validators: validators,
    className: noteEditorClassName,
    associatedUsers: associatedUsers,
    enableMentions: enableMentions,
    personas: personas
  }));
};
CompactNoteItem.propTypes = {
  editing: PropTypes.bool,
  userImage: PropTypes.string,
  userName: PropTypes.string.isRequired,
  userRole: PropTypes.string,
  noteDate: PropTypes.string,
  hideActions: PropTypes.bool,
  noteActions: PropTypes.array,
  isNoteEdited: PropTypes.bool,
  noteText: PropTypes.string,
  handleAddOrUpdate: PropTypes.func,
  validators: PropTypes.array,
  className: PropTypes.string,
  tags: PropTypes.array,
  associatedUsers: PropTypes.object,
  enableMentions: PropTypes.bool,
  personas: PropTypes.array
};
CompactNoteItem.defaultProps = {
  editing: false,
  userImage: '',
  userRole: '',
  noteDate: undefined,
  hideActions: false,
  noteActions: EMPTY_ARRAY,
  isNoteEdited: false,
  noteText: '',
  handleAddOrUpdate: _noop,
  validators: EMPTY_ARRAY,
  className: '',
  tags: EMPTY_ARRAY,
  associatedUsers: EMPTY_OBJECT,
  enableMentions: false,
  personas: EMPTY_ARRAY
};
export default CompactNoteItem;